export default __webpack_public_path__ + "static/media/DialogueandVODirection.d60e6583.png";